<template>
    <span class="gmx_link_label">
        <a>{{ title }}</a>
    </span>
</template>
  
<script setup>

import { defineProps } from 'vue';

defineProps({
    title : {
        type: String,
        default: '',
    }
});

</script>

<style lang="scss" scoped>
    
    .gmx_link_label {
        
        margin : 0 10px;
        font-size: 12px;
        color:$gmx-main-color;
        cursor:pointer;

        &:hover a {
           font-weight: bold;
           color:$gmx-main-color;
        }
    }

</style>